import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums/reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPrefix } from "features/Application/slices/models";
import accountsDataService from "features/Accounts/services/accountsDataService";
import { type LimitedAccountInfo, type UpdateLimitedAccountInfoRequest } from "features/Accounts/types";
import { type ResponseError } from "types";
import axios from "axios";
import backgroundTask from "features/BackgroundTasks/backgroundTask";
import { type AppDispatch } from "features/Application/globaltypes/redux";
import type UpdateParams from "interfaces/updateParams";

export const fetchLimitedAccountInfoPayload = {
  namespace: ReducerNamespaceTypes.Accounts,
  entity: ReducerEntityPrefixTypes.EditAccount,
  name: "fetchLimitedAccountInfo",
};
export const updateLimitedAccountInfoPayload = {
  namespace: ReducerNamespaceTypes.Accounts,
  entity: ReducerEntityPrefixTypes.EditAccount,
  name: "updateLimitedAccountInfoPayload",
};

export const fetchLimitedAccountInfo = createAsyncThunk<LimitedAccountInfo, number, { rejectValue: ResponseError }>(
  getPrefix(fetchLimitedAccountInfoPayload),
  async (accountId: number, { rejectWithValue }) => {
    try {
      return await accountsDataService.getLimitedAccountInfo(accountId);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return rejectWithValue(error.response.data as ResponseError);
      }

      return rejectWithValue({
        message: error.message || "Unknown error occurred",
        status: 500,
      });
    }
  },
);

export const updateLimitedAccountInfo = createAsyncThunk(
  getPrefix(updateLimitedAccountInfoPayload),
  async ({ accountId, data }: { accountId: number; data: UpdateLimitedAccountInfoRequest }, { dispatch }) => {
    const params: UpdateParams = {
      id: "UpdateLimitedAccountInfo",
      title: "Update account information",
      indeterminate: true,
      getMessageIds: async () => {
        const messageId = await accountsDataService.updateLimitedAccountInfo(accountId, data);
        return [messageId];
      },
      successTransientMessage: "Account information update succeeded!",
      failureTransientMessage: "Account information update failed!",
    };

    await backgroundTask.initializeBackgroundTask(params, dispatch as AppDispatch);
  },
);
